
import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";
import { technologyIcons, technologyLabels } from "./technologyIcons";

import axios from "axios";


const BRAND_API_URL = "https://c9rtj2s6a4.execute-api.eu-west-1.amazonaws.com/prod/companies/get-brand";

const OurTechnology = ({ name, tech, panelWarranty }) => {
    // Only show if tech is provided and is an object
    const techKeys = tech ? Object.keys(tech) : [];

    // Check for SolarPanel
    const solarPanelKey = techKeys.find((key) => key === "SolarPanel");
    const solarPanel = solarPanelKey ? tech[solarPanelKey] : null;
    // Use same mobile check as Navigation.js
    const isMobile = typeof window !== 'undefined' && window.innerWidth <= 600;

    // Brand info state
    const [brandInfo, setBrandInfo] = useState({});
    const [loadingBrands, setLoadingBrands] = useState(false);

    useEffect(() => {
        if (!tech) return;
        const brands = Array.from(new Set(Object.values(tech).map(t => t?.brand).filter(Boolean)));
        if (brands.length === 0) return;
        setLoadingBrands(true);
        Promise.all(
            brands.map(brandName =>
                axios.post(BRAND_API_URL, { brandName })
                    .then(res => ({ brandName, data: res.data }))
                    .catch(() => ({ brandName, data: null }))
            )
        ).then(results => {
            const info = {};
            results.forEach(({ brandName, data }) => {
                if (data) info[brandName] = data;
            });
            setBrandInfo(info);
            setLoadingBrands(false);
        });
    }, [tech]);

    return (
        <Grid
            container
            style={{
                padding: isMobile ? '60px 30px' : '60px 60px',
                backgroundColor: "#fff",
                borderRadius: "11px"
            }}
        >
            <Grid item size={12}>
                <h3
                    style={{
                        margin: 0,
                        marginBottom: 40,
                        fontSize: "26px",
                        color: "#000",
                    }}
                >
                    Our Standard Solar Installation
                </h3>
            </Grid>
            {/* Solar Panel Featured Section + 5 small cards to the right */}
            {solarPanel && (
                <Grid container spacing={4} alignItems="stretch" style={{ marginBottom: 40 }}>
                    {/* Main Solar Panel Card */}
                    <Grid item size={{ xs: 12, md: 6 }} style={{ display: 'flex', flexDirection: 'column' }}>
                        <Grid container direction="column" wrap="nowrap" style={{
                            background: "#fff",
                            border: "1px solid #ccc",
                            borderRadius: 0,
                            boxShadow: "0 4px 16px rgba(34,150,38,0.08)",
                            minHeight: 220,
                            height: '100%',
                            overflow: "hidden",
                            padding: 0,
                            margin: 0,
                            flexWrap: "nowrap",
                            display: 'flex',
                            flexDirection: 'column'
                        }}>
                            {/* Image with brand title overlay */}
                            <Grid item style={{ width: "100%", flex: 1, minHeight: 220, position: "relative", padding: 0, margin: 0, display: 'flex' }}>
                                <img
                                    src={require("./images/LONGi-Hi-MO-X6-Solar-Panels.jpg")}
                                    alt="Solar Panel"
                                    style={{ width: "100%", height: "100%", objectFit: "cover", display: "block", position: 'absolute', left: 0, top: 0 }}
                                />
                                <Grid container alignItems="center" justifyContent="center" style={{
                                    position: "absolute",
                                    left: 0,
                                    top: 0,
                                    width: "100%",
                                    height: "100%",
                                    background: "rgba(0,0,0,0.32)",
                                    pointerEvents: "none"
                                }}>
                                    <Grid item>
                                        <span style={{
                                            color: "#fff",
                                            fontSize: 36,
                                            fontWeight: 800,
                                            textShadow: "0 2px 12px rgba(0,0,0,0.45)",
                                            letterSpacing: 1,
                                            padding: "8px 32px",
                                            display: 'block',
                                            textAlign: 'center'
                                        }}>
                                            {solarPanel.brand || "Brand Name"}
                                            <br />
                                            <span style={{
                                                fontSize: 20,
                                                fontWeight: 400,
                                                color: '#e0e0e0',
                                                letterSpacing: 0.5,
                                                display: 'block',
                                                marginTop: 4
                                            }}>
                                                {solarPanel.wattage ? `${solarPanel.wattage}W Panels` : ''}
                                            </span>
                                        </span>
                                    </Grid>
                                </Grid>
                            </Grid>
                            {/* Bottom section: text left, logo right */}
                            <Grid container direction="column" style={{ padding: 36, paddingTop: 28 }}>
                                {/* Row: text left, logo right (desktop), logo above blurb (mobile) */}
                                <Grid
                                    container
                                    direction={isMobile ? "column" : "row"}
                                    alignItems={isMobile ? "center" : "flex-start"}
                                    justifyContent="space-between"
                                    wrap={isMobile ? "wrap" : "nowrap"}
                                    style={{ marginBottom: 16 }}
                                >
                                    {/* Logo on top for mobile, right for desktop */}
                                    {isMobile && (
                                        <Grid item style={{ display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 16, minWidth: 120, minHeight: 120 }}>
                                            {(() => {
                                                const brand = solarPanel?.brand;
                                                const logo = brandInfo[brand]?.logo;
                                                if (loadingBrands) {
                                                    return <Skeleton variant="rectangular" width={120} height={120} style={{ borderRadius: 12 }} />;
                                                }
                                                if (logo) {
                                                    return (
                                                        <img
                                                            src={logo}
                                                            alt={brand + " logo"}
                                                            style={{ width: 120, height: 120, objectFit: "contain", borderRadius: 12, background: "#fff", boxShadow: "0 2px 8px rgba(0,0,0,0.06)", margin: 0 }}
                                                        />
                                                    );
                                                }
                                                // No logo and not loading: show nothing
                                                return null;
                                            })()}
                                        </Grid>
                                    )}
                                    <Grid item xs>
                                        <div
                                            style={{
                                                fontSize: 18,
                                                color: "#333",
                                                textAlign: isMobile ? "center" : "left",
                                                marginBottom: isMobile ? 24 : 0 // Add more space below blurb on mobile
                                            }}
                                        >
                                            {/* Use fetched blurb if available, else fallback */}
                                            {(() => {
                                                const brand = solarPanel?.brand;
                                                const blurb = brandInfo[brand]?.attributes?.SolarPanel?.blurb;
                                                return blurb || "Leading solar panel technology for maximum efficiency and durability.";
                                            })()}
                                        </div>
                                    </Grid>
                                    {!isMobile && (
                                        <Grid item style={{ display: "flex", alignItems: "flex-start", marginLeft: 24, minWidth: 120, minHeight: 120 }}>
                                            {(() => {
                                                const brand = solarPanel?.brand;
                                                const logo = brandInfo[brand]?.logo;
                                                if (loadingBrands) {
                                                    return <Skeleton variant="rectangular" width={120} height={120} style={{ borderRadius: 12 }} />;
                                                }
                                                if (logo) {
                                                    return (
                                                        <img
                                                            src={logo}
                                                            alt={brand + " logo"}
                                                            style={{ width: 120, height: 120, objectFit: "contain", borderRadius: 12, background: "#fff", boxShadow: "0 2px 8px rgba(0,0,0,0.06)", margin: 0 }}
                                                        />
                                                    );
                                                }
                                                // No logo and not loading: show nothing
                                                return null;
                                            })()}
                                        </Grid>
                                    )}
                                </Grid>
                                {/* Row: reliability, warranty and origin */}
                                <Grid container columnSpacing={6} rowSpacing={2} style={{ fontSize: 16, color: "#444" }}>
                                    <Grid item style={{ display: "flex", flexDirection: "column" }}>
                                        <span style={{ fontWeight: 600 }}>Reliability</span>
                                        <span>
                                            {Array.from({ length: 5 }).map((_, i) => (
                                                <span key={i} style={{ color: '#FFD700', fontSize: 20, marginRight: 2 }}>★</span>
                                            ))}
                                        </span>
                                    </Grid>
                                    <Grid item style={{ display: "flex", flexDirection: "column" }}>
                                        <span style={{ fontWeight: 600 }}>Origin</span>
                                        <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                            {(() => {
                                                const brand = solarPanel?.brand;
                                                const origin = brandInfo[brand]?.attributes?.SolarPanel?.origin;
                                                var countries = require("i18n-iso-countries");
                                                countries.registerLocale(require("i18n-iso-countries/langs/en.json"));
                                                if (!origin) return 'Unknown';
                                                let countryName = countries.getName(origin, 'en');
                                                // fallback: try uppercase
                                                if (!countryName && origin.length === 2) {
                                                    countryName = countries.getName(origin.toUpperCase(), 'en');
                                                }
                                                // fallback: try lowercase
                                                if (!countryName && origin.length === 2) {
                                                    countryName = countries.getName(origin.toLowerCase(), 'en');
                                                }
                                                // Exception: Show "China" instead of "People's Republic of China"
                                                if (countryName === "People's Republic of China") {
                                                    countryName = "China";
                                                }
                                                return (
                                                    <>
                                                        <img
                                                            src={`https://flagcdn.com/w20/${origin.toLowerCase()}.png`}
                                                            alt={countryName || origin}
                                                            style={{ width: 20, height: 14, objectFit: 'cover', borderRadius: 2, marginRight: 4, verticalAlign: 'top', alignSelf: 'flex-start', marginTop: 7 }}
                                                        />
                                                        <span style={{ maxWidth: 100, whiteSpace: 'normal', wordBreak: 'break-word', display: 'inline-block' }}>{countryName || origin}</span>
                                                    </>
                                                );
                                            })()}
                                        </span>
                                    </Grid>
                                    <Grid item style={{ display: "flex", flexDirection: "column" }}>
                                        <span style={{ fontWeight: 600 }}>Warranty</span>
                                        <span>{panelWarranty ? panelWarranty : ''}</span>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    {/* 5 Small Cards Stacked Vertically, right of main card */}
                    <Grid item size={{ xs: 12, md: 6 }} style={{ display: 'flex', flexDirection: 'column', gap: 16, justifyContent: 'flex-start' }}>
                        {/* Existing technology cards with grey background */}
                        {techKeys.filter((key) => key !== "SolarPanel").slice(0, 5).map((key, idx) => {
                            const { brand, productDetails } = tech[key] || {};
                            // Determine extra info for top right
                            let extraInfo = null;
                            if (key === 'EVCharger' && tech[key]?.model) {
                                extraInfo = `${tech[key].model}`;
                            } else if (key === 'SolarBattery' && tech[key]?.capacity) {
                                extraInfo = `${tech[key].capacity} kWh`;
                            } else if (key === 'SolarInverter' && tech[key]?.powerRating) {
                                extraInfo = `${tech[key].powerRating} kW`;
                            }
                            // Get logo for this brand if available
                            const logo = brandInfo[brand]?.logo;
                            return (
                                <Grid key={key} container direction="column" style={{
                                    background: '#fff',
                                    border: '1px solid #ccc',
                                    borderRadius: 0,
                                    boxShadow: '0 4px 16px rgba(34,150,38,0.08)',
                                    marginBottom: 0,
                                    padding: 0,
                                    width: '100%',
                                    overflow: 'hidden',
                                    position: 'relative', // Needed for absolute positioning
                                }}>
                                    {/* Extra info floated top right */}
                                    {extraInfo && (
                                        <div style={{
                                            position: 'absolute',
                                            top: 20,
                                            right: 30,
                                            fontSize: 16,
                                            color: '#888',
                                            fontWeight: 400,
                                            borderRadius: 8,
                                            zIndex: 2,
                                            whiteSpace: 'nowrap',
                                            maxWidth: 120,
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                        }}>{extraInfo}</div>
                                    )}
                                    {/* Top row: logo left, text right */}
                                    <Grid container alignItems="flex-start" wrap="nowrap" style={{ padding: 20, paddingBottom: 20, flexWrap: 'nowrap' }}>
                                        <Grid item style={{ marginRight: 20, flexShrink: 0, display: 'flex', alignItems: 'flex-start' }}>
                                            {loadingBrands ? (
                                                <Skeleton variant="circular" width={56} height={56} style={{ borderRadius: 12 }} />
                                            ) : logo ? (
                                                <img
                                                    src={logo}
                                                    alt={brand + " logo"}
                                                    style={{ width: 56, height: 56, objectFit: 'contain', borderRadius: 12, background: '#fff', display: 'block', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}
                                                />
                                            ) : null}
                                        </Grid>
                                        <Grid item xs style={{ minWidth: 0, justifyContent: 'space-between' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                <span style={{ fontWeight: 700, fontSize: 18, color: '#229626', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{brand || 'Brand Name'}</span>
                                            </div>
                                            <div style={{ fontSize: 13, color: '#888', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{technologyLabels[key] || 'Product Type'}</div>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            );
                        })}
                    </Grid>
                </Grid>
            )}
            {/* Other Technologies */}
            <Grid item size={12}>
                {techKeys.length === 0 ? (
                    <p>No technology details available.</p>
                ) : null}
            </Grid>
        </Grid>
    );
};

export default OurTechnology;
